import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { createOrderUrl } from "@saleor/createOrder/urls";
import ContractDetail from "@saleor/createOrderExport/components/ContractDetail";
import { ExportPiQueryParams } from "@saleor/createOrderExport/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";
import { useIntl } from "react-intl";

interface ContractDetailProps {
  id: string;
  params: ExportPiQueryParams;
}

const ContractDetailView: React.FC<ContractDetailProps> = props => {
  const { id, params } = props;
  const intl = useIntl();
  const navigate = useNavigator();

  const handleBack = () => {
    navigate(createOrderUrl);
  };

  return (
    <Container>
      <AppHeader onBack={handleBack}>
        {intl.formatMessage({ defaultMessage: "กลับไป" })}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage({ defaultMessage: "Add to cart" })}
      />
      <ContractDetail id={id} params={params} />
    </Container>
  );
};

ContractDetailView.displayName = "ContractDetail";
export default ContractDetailView;
